import { render } from "./DocumentGenerationProgress.vue?vue&type=template&id=78056585&scoped=true"
import script from "./DocumentGenerationProgress.vue?vue&type=script&lang=js"
export * from "./DocumentGenerationProgress.vue?vue&type=script&lang=js"

import "./DocumentGenerationProgress.vue?vue&type=style&index=0&id=78056585&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-78056585"

export default script